export class PartyMaster {
    public ACC_CODE!: string;
    public ACC_TYPE!: string;
    public ACC_NAME!: string;
    public ACC_ADD1!: string;
    public ACC_ADD2!: string;
    public ACC_ADD3!: string;
    public ACC_CITY!: string;
    public ACC_GLCODE!: string;
    public ACC_PHONE1!: string;
    public ACC_PHONE2!: string;
    public ACC_PHONE3!: string;
    public ACC_PHONE4!: string;
    public ACC_MOBILE1!: string;
    public ACC_MOBILE2!: string;
    public ACC_FAX1!: string;
    public ACC_FAX2!: string;
    public ACC_EMAIL1!: string;
    public ACC_EMAIL2!: string;
    public ACC_WEBSITE!: string;
    public ACC_LSTNO!: string;
    public ACC_LSTDATE!: Date;
    public ACC_CSTNO!: string;
    public ACC_CSTDATE!: Date;
    public ACC_REGNO!: string;
    public ACC_REGDATE!: Date;
    public ACC_DELTERM!: string;
    public ACC_PAYTERM!: string;
    public ACC_LT!: string;
    public ACC_DP!: number;
    public ACC_CL!: number;
    public ACC_PRICELIST!: string;
    public ACC_CAT!: string;
    public ACC_SALEPER!: string;
    public ACC_DISC!: number;
    public ACC_ROUTE!: string;
    public ACC_FRTPKG!: number;
    public ACC_UID!: string;
    public ACC_PWD!: string;
    public ACC_BILLABLE!: boolean;
    public ACC_ACTIVE!: boolean;
    public ACC_PUBLISH!: number;
    public IsLoginActive!: boolean;
    public ACC_OPENING!: number;
    public ACC_BALANCE!: number;
    public SMS!: boolean;
    public EMAIL!: boolean;
    public BOOKING!: boolean;
    public DELIVERY!: boolean;
    public MIS!: boolean;
    public MAIL_HOUR!: number;
    public ACC_3P!: string;
    public ACC_CFT!: number;
    public MIN_WEIGHT!: number;
    public MIN_FREIGHT!: number;
    public FOV_PERCENT!: number;
    public ODA_CHARGES!: number;
    public ACC_WTPERBOX!: number;
    public ONLINE_BOOKING!: boolean;
    public FREIGHT_ON!: boolean;
    public VEH_TYPE!: string;
    public IS_GREENTAX_APPLICABLE!: boolean;
    public CREATEDBY_USERID!: Number;
    public UPDATEDBY_USERID!: Number;
    public CREATED_DATE!: Date;
    public UPDATED_DATE!: Date;
}